import { render, staticRenderFns } from "./BancaEmaticaRichiesteRepartoEdit.vue?vue&type=template&id=79845bae"
import script from "./BancaEmaticaRichiesteRepartoEdit.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaRichiesteRepartoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports